import { useQuery } from 'react-query';
import { getRequestNotes } from 'RestAPIs/roster/notes';

const useGetRequestNotes = (
  { requestId },
  options: Record<string, any> = {}
) => {
  return useQuery(
    ['requestNotes', 'list', requestId],
    async () => {
      const { data } = await getRequestNotes(requestId);
      return data;
    },
    { ...options }
  );
};

export default useGetRequestNotes;
